import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const MarkReadIconButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: inherit;
`;

export const FlexContainerStyled = styled(FlexContainer)`
  padding: 2rem;
`;
